export default [
  {
    path: '/system/message',
    name: 'system-message',
    component: () => import('@/views/system/message/index'),
    meta: {
      title: '消息中心'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/system.js